import { Skeleton } from 'components/Skeleton'
import { GeneratingMediaOverlay } from '../components/AssetMedia'

export function InstagramPostSkeletonPreview() {
  return (
    <div
      className="relative w-full max-w-md rounded-2xl bg-white transition-all duration-300"
      style={{ border: '1px solid transparent' }}
    >
      <GeneratingMediaOverlay radius={16} />

      {/* 10 px inset so no content touches the snake border */}
      <div className="p-[10px]">
        {/* Header — avatar + username */}
        <div className="flex items-center gap-3 px-2 py-2">
          <Skeleton className="h-8 w-8 shrink-0 rounded-full" />
          <Skeleton className="h-3 w-24 rounded" />
        </div>

        {/* Image — square placeholder, rounded so it sits cleanly inside the card */}
        <Skeleton className="aspect-square w-full rounded-xl" />

        {/* Caption — username + text lines */}
        <div className="flex flex-col gap-2 px-2 pt-3 pb-2">
          <div className="flex gap-2">
            <Skeleton className="h-3 w-20 rounded" />
            <Skeleton className="h-3 w-48 rounded" />
          </div>
          <Skeleton className="h-3 w-[85%] rounded" />
          <Skeleton className="h-3 w-[60%] rounded" />
        </div>

        {/* Hashtags */}
        <div className="px-2 pb-2">
          <Skeleton className="h-3 w-44 rounded" />
        </div>

        {/* Timestamp */}
        <div className="border-t px-2 py-2">
          <Skeleton className="h-2 w-16 rounded" />
        </div>
      </div>
    </div>
  )
}
